import React, { useState } from "react";
import {
  Dropdown,
  Header,
  Icon,
  Modal,
  Image,
  Button,
} from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const Preferenze = ({
  selectedArea,
  setSelectedArea,
  selectedSpecialita,
  setSelectedSpecialita,
  selectedLivello,
  setSelectedLivello,
  selectedLingua,
  setSelectedLingua,
  selectedNumAllevi,
  setSelectedNumAllevi,
  datiScuola,
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const formatDescription = (text) => {
    if (!text) return "";
    return text.replace(/\\r\\n/g, "<br/>").replace(/\r\n/g, "<br/>");
  };

  // Transform data for Semantic UI Dropdown format
  const areaOptions = Object.entries(datiScuola?.areeOperative || {}).map(
    ([id, obj]) => ({
      key: id,
      value: id,
      text: obj.text,
    })
  );

  const specialitaOptions = Object.entries(
    datiScuola?.["specialità"] || {}
  ).map(([id, obj]) => ({
    key: id,
    value: id,
    text: obj.text,
  }));

  const livelloOptions = Object.entries(datiScuola?.livelli || {}).map(
    ([id, obj]) => ({
      key: id,
      value: id,
      text: obj.text,
      image:
        obj.simbolo != null
          ? {
            avatar: false,
            src: require(`../../assets/images/livelli/${obj.simbolo}.jpg`),
          }
          : undefined,
    })
  );

  const linguaOptions = Object.values(datiScuola?.linguePrivate || {}).map(
    (lingua) => ({
      key: lingua.id,
      value: lingua.isoCode,
      text: lingua.isoCode,
    })
  );

  const numAlleviOptions = [1, 2, 3, 4, 5].map((num) => ({
    key: num,
    value: num,
    text: num.toString(),
  }));

  return (
    <div>
      {/* <Header as="h2">{t("preferenze")}</Header> */}
      <h2>{t("preferenze")}</h2>

      {/* Area Operativa */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          <Icon name="map marker alternate" style={{ marginRight: "0.5rem" }} />
          {t("area_operativa")}
        </label>
        <Dropdown
          placeholder={t("seleziona_area")}
          fluid
          selection
          options={areaOptions}
          value={selectedArea || ""}
          onChange={(e, { value }) => setSelectedArea(value)}
        />
      </div>

      {/* Specialità */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          <Icon name="skiing" style={{ marginRight: "0.5rem" }} />
          {t("specialita")}
        </label>
        <Dropdown
          placeholder={t("seleziona_specialita")}
          fluid
          selection
          options={specialitaOptions}
          value={selectedSpecialita || ""}
          onChange={(e, { value }) => setSelectedSpecialita(value)}
        />
      </div>

      {/* Livello */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          <Icon name="star" style={{ marginRight: "0.5rem" }} />
          {t("livello")}
          {selectedLivello &&
            datiScuola?.livelli?.[selectedLivello]?.descrizione && (
              <Icon
                name="info circle"
                style={{
                  marginLeft: "0.5rem",
                  cursor: "pointer",
                  color: "#2185d0",
                }}
                onClick={() => setModalOpen(true)}
              />
            )}
        </label>
        <Dropdown
          placeholder={t("seleziona_livello")}
          fluid
          selection
          options={livelloOptions}
          value={selectedLivello || ""}
          onChange={(e, { value }) => setSelectedLivello(value)}
        />
      </div>

      {/* Modal for Livello Description */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} size="small">
        <Modal.Header>
          {selectedLivello && datiScuola?.livelli?.[selectedLivello]?.text}
        </Modal.Header>
        <Modal.Content>
          <div style={{ textAlign: "center" }}>
            {selectedLivello &&
              datiScuola?.livelli?.[selectedLivello]?.simbolo != null && (
                <Image
                  src={require(`../../assets/images/livelli/${datiScuola.livelli[selectedLivello].simbolo}.jpg`)}
                  size="tiny"
                  centered
                  style={{ marginBottom: "1rem" }}
                />
              )}
            {selectedLivello &&
              datiScuola?.livelli?.[selectedLivello]?.descrizione && (
                <p
                  style={{ textAlign: "left", color: "rgba(48, 48, 48, 0.87)" }}
                  dangerouslySetInnerHTML={{
                    __html: formatDescription(
                      datiScuola.livelli[selectedLivello].descrizione
                    ),
                  }}
                />
              )}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setModalOpen(false)} primary>
            {t("chiudi") || "Close"}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Lingua */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          <Icon name="language" style={{ marginRight: "0.5rem" }} />
          {t("lingua")}
        </label>
        <Dropdown
          placeholder={t("seleziona_lingua")}
          fluid
          selection
          options={linguaOptions}
          value={selectedLingua || ""}
          onChange={(e, { value }) => setSelectedLingua(value)}
        />
      </div>

      {/* Numero Allievi */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          <Icon name="users" style={{ marginRight: "0.5rem" }} />
          {t("numero_allievi")}
        </label>
        <Dropdown
          placeholder={t("seleziona_numero")}
          fluid
          selection
          options={numAlleviOptions}
          value={selectedNumAllevi || ""}
          onChange={(e, { value }) => setSelectedNumAllevi(value)}
        />
      </div>
    </div>
  );
};

export default Preferenze;
